import Icon from '../components/Icon.vue'

Icon.register({
  anchor: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M13 352H45.4C67.2 454.7 181.9 512 288 512 394.2 512 508.9 454.6 530.6 352H563C573.7 352 579.1 339.1 571.5 331.5L504.5 264.5C499.8 259.8 492.2 259.8 487.5 264.5L420.5 331.5C412.9 339.1 418.3 352 429 352H464.1C443.8 406.3 379.2 438.6 320 446V256H372C378.6 256 384 250.6 384 244V204C384 197.4 378.6 192 372 192H320V186.5C357.3 173.4 384 137.8 384 96 384 43.8 341.6 0.7 289.4 0 235.7-0.7 192 42.5 192 96 192 137.8 218.7 173.4 256 186.5V192H204C197.4 192 192 197.4 192 204V244C192 250.6 197.4 256 204 256H256V446C197.1 438.6 132.2 406.3 111.9 352H147C157.7 352 163.1 339.1 155.5 331.5L88.5 264.5C83.8 259.8 76.2 259.8 71.5 264.5L4.5 331.5C-3.1 339.1 2.3 352 13 352zM288 64C305.6 64 320 78.4 320 96S305.6 128 288 128 256 113.6 256 96 270.4 64 288 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/anchor.js
// module id = QELs
// module chunks = 144